import { BorderedCard } from '@aibees/shared/components';
import { HEADER } from '@aibees/shared/layouts/config-layout';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-items: center;
  height: 100%;
`;

export const Content = styled(BorderedCard)<{
  hasSearchBar: boolean;
  isChartView?: boolean;
}>`
  display: flex;
  flex-direction: row;
  padding: ${(p) => p.theme.spacing(1.5)};
  margin: ${(p) => p.theme.spacing(1)};
  width: auto;
  height: ${(p) =>
    p.isChartView
      ? '100%'
      : `calc(100vh - ${
          HEADER.TOP + 18 + (p.hasSearchBar ? 50 : 0)
        }px);`}; // 50 is the height of the search bar and 18 is the sum of top and bottom margin of the card itself
`;
